import DsInputRangeSlider, {
  type InputRangeSliderProps
} from '@carvana/ds-input-range-slider';
import { createComponent } from '@carvana/merch-components';

const InputRangeSlider = createComponent<InputRangeSliderProps>(
  DsInputRangeSlider,
  {
    debounceDelay: 2000
  }
);

export default InputRangeSlider;
